[
  {
    "id": "training_dummy",
    "name": "Training Dummy",
    "level": 1,
    "hp": 5000,
    "xp": 0,
    "ap": 0,
    "def": 0,
    "attackIntervalMs": 2000,
    "attackRange": 1,
    "aggroRadius": 0,
    "leashRadius": 1,
    "moveSpeed": 0.1,
    "radius": 0.5,
    "respawnMs": [5000, 5000],
    "color": "#c8a860",
    "scale": 1.05,
    "model": "humanoid:dummy",
    "dummy": true
  },
  {
    "id": "bristle_boar",
    "name": "Bristle Boar",
    "level": 1,
    "hp": 120,
    "xp": 30,
    "ap": 10,
    "def": 2,
    "attackIntervalMs": 2000,
    "attackRange": 2,
    "aggroRadius": 0,
    "leashRadius": 30,
    "moveSpeed": 4.5,
    "radius": 0.6,
    "respawnMs": [25000, 35000],
    "color": "#8a6a4a",
    "scale": 1,
    "model": "boar"
  },
  {
    "id": "ash_wolf",
    "name": "Ash Wolf",
    "level": 2,
    "hp": 150,
    "xp": 55,
    "ap": 12,
    "def": 3,
    "attackIntervalMs": 1600,
    "attackRange": 2,
    "aggroRadius": 0,
    "leashRadius": 35,
    "moveSpeed": 5.5,
    "radius": 0.6,
    "respawnMs": [25000, 35000],
    "color": "#6d6d72",
    "scale": 1,
    "model": "wolf"
  },
  {
    "id": "mire_toad",
    "name": "Mire Toad",
    "level": 3,
    "hp": 210,
    "xp": 95,
    "ap": 15,
    "def": 5,
    "attackIntervalMs": 2200,
    "attackRange": 2,
    "aggroRadius": 0,
    "leashRadius": 30,
    "moveSpeed": 3.5,
    "radius": 0.7,
    "respawnMs": [25000, 35000],
    "color": "#4f7a3a",
    "scale": 1.2,
    "model": "toad"
  },
  {
    "id": "stone_husk",
    "name": "Stone Husk",
    "level": 5,
    "hp": 420,
    "xp": 260,
    "ap": 22,
    "def": 10,
    "attackIntervalMs": 2400,
    "attackRange": 2.5,
    "aggroRadius": 0,
    "leashRadius": 25,
    "moveSpeed": 4,
    "radius": 1,
    "respawnMs": [30000, 45000],
    "color": "#9a8f80",
    "scale": 1.6,
    "model": "golem"
  },
  {
    "id": "thornback_boar",
    "name": "Thornback Boar",
    "level": 8,
    "hp": 700,
    "xp": 520,
    "ap": 32,
    "def": 16,
    "attackIntervalMs": 2000,
    "attackRange": 2,
    "aggroRadius": 0,
    "leashRadius": 35,
    "moveSpeed": 4.8,
    "radius": 0.7,
    "respawnMs": [30000, 45000],
    "color": "#5a3a24",
    "scale": 1.25,
    "model": "boar:thorn"
  },
  {
    "id": "bandit",
    "name": "Bandit",
    "level": 11,
    "hp": 950,
    "xp": 900,
    "ap": 42,
    "def": 22,
    "attackIntervalMs": 1700,
    "attackRange": 2,
    "aggroRadius": 0,
    "leashRadius": 35,
    "moveSpeed": 4.6,
    "radius": 0.5,
    "respawnMs": [30000, 45000],
    "color": "#3a4a32",
    "scale": 1,
    "model": "humanoid:bandit"
  },
  {
    "id": "alpha_wolf",
    "name": "Alpha Wolf",
    "level": 14,
    "hp": 1250,
    "xp": 1400,
    "ap": 52,
    "def": 28,
    "attackIntervalMs": 1500,
    "attackRange": 2,
    "aggroRadius": 0,
    "leashRadius": 35,
    "moveSpeed": 5.8,
    "radius": 0.7,
    "respawnMs": [30000, 45000],
    "color": "#b8b8c0",
    "scale": 1.3,
    "model": "wolf:alpha"
  },
  {
    "id": "mire_lurker",
    "name": "Mire Lurker",
    "level": 17,
    "hp": 1600,
    "xp": 2100,
    "ap": 62,
    "def": 34,
    "attackIntervalMs": 2200,
    "attackRange": 2.5,
    "aggroRadius": 0,
    "leashRadius": 35,
    "moveSpeed": 3.6,
    "radius": 0.9,
    "respawnMs": [30000, 45000],
    "color": "#2e4a26",
    "scale": 1.6,
    "model": "toad:lurker"
  },
  {
    "id": "barrow_skeleton",
    "name": "Barrow Skeleton",
    "level": 20,
    "hp": 2000,
    "xp": 3000,
    "ap": 74,
    "def": 42,
    "attackIntervalMs": 1800,
    "attackRange": 2,
    "aggroRadius": 0,
    "leashRadius": 35,
    "moveSpeed": 4.2,
    "radius": 0.5,
    "respawnMs": [30000, 45000],
    "color": "#d8d2c0",
    "scale": 1,
    "model": "humanoid:skeleton"
  },
  {
    "id": "cave_bear",
    "name": "Cave Bear",
    "level": 22,
    "hp": 2400,
    "xp": 3700,
    "ap": 82,
    "def": 46,
    "attackIntervalMs": 2100,
    "attackRange": 2.5,
    "aggroRadius": 6,
    "leashRadius": 35,
    "moveSpeed": 4.8,
    "radius": 1,
    "respawnMs": [35000, 50000],
    "color": "#5a3e2a",
    "scale": 1.3,
    "model": "bear"
  },
  {
    "id": "forest_troll",
    "name": "Forest Troll",
    "level": 26,
    "hp": 3100,
    "xp": 5200,
    "ap": 96,
    "def": 54,
    "attackIntervalMs": 2300,
    "attackRange": 2.8,
    "aggroRadius": 6,
    "leashRadius": 35,
    "moveSpeed": 4.2,
    "radius": 0.9,
    "respawnMs": [35000, 50000],
    "color": "#4f7a7a",
    "scale": 1.4,
    "model": "humanoid:troll"
  },
  {
    "id": "granite_golem",
    "name": "Granite Golem",
    "level": 30,
    "hp": 3900,
    "xp": 6100,
    "ap": 110,
    "def": 64,
    "attackIntervalMs": 2600,
    "attackRange": 3,
    "aggroRadius": 5,
    "leashRadius": 35,
    "moveSpeed": 3.8,
    "radius": 1.2,
    "respawnMs": [35000, 50000],
    "color": "#6a6a70",
    "scale": 1.8,
    "model": "golem:granite"
  },
  {
    "id": "dire_wolf",
    "name": "Dire Wolf",
    "level": 34,
    "hp": 4700,
    "xp": 6650,
    "ap": 124,
    "def": 72,
    "attackIntervalMs": 1500,
    "attackRange": 2.2,
    "aggroRadius": 7,
    "leashRadius": 35,
    "moveSpeed": 6.2,
    "radius": 0.8,
    "respawnMs": [35000, 50000],
    "color": "#2a2a30",
    "scale": 1.5,
    "model": "wolf:dire"
  },
  {
    "id": "ogre_brute",
    "name": "Ogre Brute",
    "level": 38,
    "hp": 5600,
    "xp": 7750,
    "ap": 140,
    "def": 82,
    "attackIntervalMs": 2600,
    "attackRange": 3,
    "aggroRadius": 6,
    "leashRadius": 35,
    "moveSpeed": 4.2,
    "radius": 1.1,
    "respawnMs": [35000, 50000],
    "color": "#9a7a5a",
    "scale": 1.7,
    "model": "humanoid:ogre"
  },
  {
    "id": "ash_revenant",
    "name": "Ash Revenant",
    "level": 42,
    "hp": 6800,
    "xp": 8950,
    "ap": 158,
    "def": 92,
    "attackIntervalMs": 1800,
    "attackRange": 2.2,
    "aggroRadius": 6,
    "leashRadius": 35,
    "moveSpeed": 4.6,
    "radius": 0.6,
    "respawnMs": [40000, 55000],
    "color": "#8a8680",
    "scale": 1.2,
    "model": "humanoid:revenant"
  },
  {
    "id": "hellhound",
    "name": "Hellhound",
    "level": 46,
    "hp": 8000,
    "xp": 11200,
    "ap": 175,
    "def": 100,
    "attackIntervalMs": 1400,
    "attackRange": 2.2,
    "aggroRadius": 8,
    "leashRadius": 35,
    "moveSpeed": 6.6,
    "radius": 0.8,
    "respawnMs": [40000, 55000],
    "color": "#3a1410",
    "scale": 1.4,
    "model": "wolf:hell"
  },
  {
    "id": "obsidian_golem",
    "name": "Obsidian Golem",
    "level": 50,
    "hp": 9800,
    "xp": 14300,
    "ap": 195,
    "def": 112,
    "attackIntervalMs": 2600,
    "attackRange": 3.2,
    "aggroRadius": 5,
    "leashRadius": 35,
    "moveSpeed": 3.8,
    "radius": 1.3,
    "respawnMs": [40000, 55000],
    "color": "#1e1a22",
    "scale": 2,
    "model": "golem:obsidian"
  },
  {
    "id": "cinder_warden",
    "name": "Cinder Warden",
    "level": 54,
    "hp": 11600,
    "xp": 17900,
    "ap": 214,
    "def": 122,
    "attackIntervalMs": 2000,
    "attackRange": 2.4,
    "aggroRadius": 6,
    "leashRadius": 35,
    "moveSpeed": 4.6,
    "radius": 0.7,
    "respawnMs": [40000, 55000],
    "color": "#2e2a36",
    "scale": 1.3,
    "model": "humanoid:warden"
  },
  {
    "id": "magma_behemoth",
    "name": "Magma Behemoth",
    "level": 58,
    "hp": 13600,
    "xp": 22400,
    "ap": 234,
    "def": 133,
    "attackIntervalMs": 2800,
    "attackRange": 3.4,
    "aggroRadius": 5,
    "leashRadius": 35,
    "moveSpeed": 3.8,
    "radius": 1.4,
    "respawnMs": [40000, 55000],
    "color": "#5a1e0e",
    "scale": 2.1,
    "model": "golem:magma"
  },
  {
    "id": "gloom_stalker",
    "name": "Gloom Stalker",
    "level": 60,
    "hp": 14800,
    "xp": 25200,
    "ap": 245,
    "def": 139,
    "attackIntervalMs": 1300,
    "attackRange": 2.2,
    "aggroRadius": 8,
    "leashRadius": 35,
    "moveSpeed": 6.8,
    "radius": 0.8,
    "respawnMs": [40000, 55000],
    "color": "#1c1a2a",
    "scale": 1.5,
    "model": "wolf:gloom"
  },
  {
    "id": "old_tusk",
    "name": "Old Tusk",
    "level": 12,
    "hp": 7000,
    "xp": 11000,
    "ap": 55,
    "def": 26,
    "attackIntervalMs": 2000,
    "attackRange": 3,
    "aggroRadius": 10,
    "leashRadius": 40,
    "moveSpeed": 5.0,
    "radius": 1.2,
    "respawnMs": [1200000, 1800000],
    "color": "#6a4a2a",
    "scale": 2.3,
    "model": "boar:thorn",
    "boss": true,
    "abilities": [
      {
        "id": "ground_gore",
        "name": "Ground Gore",
        "kind": "slam",
        "radius": 5,
        "mult": 1.4,
        "castMs": 1200,
        "cooldownMs": 10000,
        "status": {
          "kind": "stun",
          "durationMs": 1000
        }
      },
      {
        "id": "tusk_sweep",
        "name": "Tusk Sweep",
        "kind": "cleave",
        "radius": 4.5,
        "mult": 1.6,
        "castMs": 800,
        "cooldownMs": 7000
      }
    ]
  },
  {
    "id": "barrow_king",
    "name": "The Barrow King",
    "level": 28,
    "hp": 24000,
    "xp": 64800,
    "ap": 125,
    "def": 64,
    "attackIntervalMs": 2000,
    "attackRange": 3,
    "aggroRadius": 12,
    "leashRadius": 40,
    "moveSpeed": 4.4,
    "radius": 0.9,
    "respawnMs": [1800000, 2700000],
    "color": "#7a7a60",
    "scale": 1.9,
    "model": "humanoid:skeleton",
    "boss": true,
    "abilities": [
      {
        "id": "grave_chill",
        "name": "Grave Chill",
        "kind": "nova",
        "radius": 8,
        "mult": 1.2,
        "castMs": 1500,
        "cooldownMs": 16000,
        "status": {
          "kind": "slow",
          "durationMs": 3000,
          "pct": 40
        }
      },
      {
        "id": "rusted_reaping",
        "name": "Rusted Reaping",
        "kind": "cleave",
        "radius": 5.5,
        "mult": 1.8,
        "castMs": 900,
        "cooldownMs": 8000
      },
      {
        "id": "bone_rain",
        "name": "Bone Rain",
        "kind": "meteor",
        "radius": 3.5,
        "mult": 1.6,
        "castMs": 1600,
        "cooldownMs": 12000
      }
    ]
  },
  {
    "id": "mossback",
    "name": "Mossback the Ancient",
    "level": 36,
    "hp": 42000,
    "xp": 92400,
    "ap": 170,
    "def": 90,
    "attackIntervalMs": 2400,
    "attackRange": 3.5,
    "aggroRadius": 12,
    "leashRadius": 45,
    "moveSpeed": 4.2,
    "radius": 1.4,
    "respawnMs": [2400000, 3600000],
    "color": "#3f5a2a",
    "scale": 2.3,
    "model": "humanoid:troll",
    "boss": true,
    "abilities": [
      {
        "id": "root_stomp",
        "name": "Root Stomp",
        "kind": "slam",
        "radius": 7,
        "mult": 1.6,
        "castMs": 1500,
        "cooldownMs": 13000,
        "status": {
          "kind": "stun",
          "durationMs": 1500
        }
      },
      {
        "id": "club_sweep",
        "name": "Club Sweep",
        "kind": "cleave",
        "radius": 6,
        "mult": 1.9,
        "castMs": 900,
        "cooldownMs": 8000
      },
      {
        "id": "spore_cloud",
        "name": "Spore Cloud",
        "kind": "nova",
        "radius": 10,
        "mult": 1.1,
        "castMs": 1800,
        "cooldownMs": 17000,
        "status": {
          "kind": "slow",
          "durationMs": 3000,
          "pct": 35
        }
      }
    ]
  },
  {
    "id": "cinder_tyrant",
    "name": "The Cinder Tyrant",
    "level": 64,
    "hp": 90000,
    "xp": 168000,
    "ap": 300,
    "def": 160,
    "attackIntervalMs": 2000,
    "attackRange": 3,
    "aggroRadius": 12,
    "leashRadius": 45,
    "moveSpeed": 4.6,
    "radius": 1.2,
    "respawnMs": [2400000, 3600000],
    "color": "#8a2a10",
    "scale": 2.2,
    "model": "humanoid:warden",
    "boss": true,
    "abilities": [
      {
        "id": "cinderfall",
        "name": "Cinderfall",
        "kind": "meteor",
        "radius": 4.5,
        "mult": 2.0,
        "castMs": 1600,
        "cooldownMs": 11000
      },
      {
        "id": "searing_wave",
        "name": "Searing Wave",
        "kind": "nova",
        "radius": 11,
        "mult": 1.4,
        "castMs": 1600,
        "cooldownMs": 16000,
        "status": {
          "kind": "slow",
          "durationMs": 3000,
          "pct": 40
        }
      },
      {
        "id": "tyrants_edge",
        "name": "Tyrant's Edge",
        "kind": "cleave",
        "radius": 6,
        "mult": 2.1,
        "castMs": 900,
        "cooldownMs": 8000
      }
    ]
  },
  {
    "id": "hellmaw",
    "name": "Hellmaw",
    "level": 66,
    "hp": 95000,
    "xp": 185000,
    "ap": 315,
    "def": 165,
    "attackIntervalMs": 1500,
    "attackRange": 3,
    "aggroRadius": 14,
    "leashRadius": 45,
    "moveSpeed": 7.0,
    "radius": 1.4,
    "respawnMs": [2400000, 3600000],
    "color": "#5a1010",
    "scale": 2.8,
    "model": "wolf:hell",
    "boss": true,
    "abilities": [
      {
        "id": "rending_bite",
        "name": "Rending Bite",
        "kind": "cleave",
        "radius": 5,
        "mult": 2.0,
        "castMs": 700,
        "cooldownMs": 7000
      },
      {
        "id": "howl_of_ruin",
        "name": "Howl of Ruin",
        "kind": "slam",
        "radius": 9,
        "mult": 1.3,
        "castMs": 1400,
        "cooldownMs": 15000,
        "status": {
          "kind": "stun",
          "durationMs": 1200
        }
      },
      {
        "id": "hellfire_spit",
        "name": "Hellfire Spit",
        "kind": "meteor",
        "radius": 4,
        "mult": 1.9,
        "castMs": 1300,
        "cooldownMs": 10000
      }
    ]
  },
  {
    "id": "grak_warlord",
    "name": "Grak the Warlord",
    "level": 70,
    "hp": 110000,
    "xp": 235000,
    "ap": 340,
    "def": 180,
    "attackIntervalMs": 2200,
    "attackRange": 3.5,
    "aggroRadius": 12,
    "leashRadius": 45,
    "moveSpeed": 4.6,
    "radius": 1.6,
    "respawnMs": [1200000, 1800000],
    "color": "#6a2a20",
    "scale": 2.1,
    "model": "humanoid:warlord",
    "boss": true,
    "abilities": [
      {
        "id": "war_stomp",
        "name": "War Stomp",
        "kind": "slam",
        "radius": 7,
        "mult": 1.6,
        "castMs": 1500,
        "cooldownMs": 12000,
        "status": {
          "kind": "stun",
          "durationMs": 1500
        }
      },
      {
        "id": "cleaving_sweep",
        "name": "Cleaving Sweep",
        "kind": "cleave",
        "radius": 6.5,
        "mult": 2.0,
        "castMs": 900,
        "cooldownMs": 8000
      },
      {
        "id": "rain_of_embers",
        "name": "Rain of Embers",
        "kind": "meteor",
        "radius": 4,
        "mult": 1.8,
        "castMs": 1800,
        "cooldownMs": 15000
      }
    ]
  },
  {
    "id": "ancient_colossus",
    "name": "Ancient Colossus",
    "level": 70,
    "hp": 160000,
    "xp": 347000,
    "ap": 380,
    "def": 200,
    "attackIntervalMs": 3000,
    "attackRange": 4.5,
    "aggroRadius": 12,
    "leashRadius": 45,
    "moveSpeed": 3.4,
    "radius": 2.4,
    "respawnMs": [2700000, 3600000],
    "color": "#2a2430",
    "scale": 2.8,
    "model": "golem:colossus",
    "boss": true,
    "abilities": [
      {
        "id": "earthshatter",
        "name": "Earthshatter",
        "kind": "slam",
        "radius": 9,
        "mult": 1.8,
        "castMs": 2000,
        "cooldownMs": 14000,
        "status": {
          "kind": "stun",
          "durationMs": 2000
        }
      },
      {
        "id": "molten_ring",
        "name": "Molten Ring",
        "kind": "nova",
        "radius": 13,
        "mult": 1.4,
        "castMs": 1600,
        "cooldownMs": 18000,
        "status": {
          "kind": "slow",
          "durationMs": 3000,
          "pct": 40
        }
      },
      {
        "id": "boulder_hurl",
        "name": "Boulder Hurl",
        "kind": "meteor",
        "radius": 4,
        "mult": 2.2,
        "castMs": 1400,
        "cooldownMs": 9000
      }
    ]
  },
  {
    "id": "gnarlhide",
    "name": "Gnarlhide",
    "level": 16,
    "hp": 5600,
    "xp": 10500,
    "ap": 84,
    "def": 41,
    "attackIntervalMs": 2100,
    "attackRange": 3,
    "aggroRadius": 10,
    "leashRadius": 40,
    "moveSpeed": 4.8,
    "radius": 1.3,
    "respawnMs": [600000, 600000],
    "color": "#5a4030",
    "scale": 1.9,
    "model": "bear",
    "boss": true,
    "abilities": [
      {
        "id": "maul_swipe",
        "name": "Maul Swipe",
        "kind": "cleave",
        "radius": 4.5,
        "mult": 1.6,
        "castMs": 900,
        "cooldownMs": 8000
      },
      {
        "id": "bristling_roar",
        "name": "Bristling Roar",
        "kind": "nova",
        "radius": 8,
        "mult": 1.1,
        "castMs": 1400,
        "cooldownMs": 15000,
        "status": {
          "kind": "slow",
          "durationMs": 3000,
          "pct": 30
        }
      }
    ]
  },
  {
    "id": "redmane",
    "name": "Redmane",
    "level": 22,
    "hp": 8400,
    "xp": 18500,
    "ap": 111,
    "def": 55,
    "attackIntervalMs": 2100,
    "attackRange": 3,
    "aggroRadius": 10,
    "leashRadius": 40,
    "moveSpeed": 4.8,
    "radius": 1.0,
    "respawnMs": [600000, 600000],
    "color": "#8a2a1a",
    "scale": 1.8,
    "model": "wolf:alpha",
    "boss": true,
    "abilities": [
      {
        "id": "rending_leap",
        "name": "Rending Leap",
        "kind": "slam",
        "radius": 4,
        "mult": 1.5,
        "castMs": 1000,
        "cooldownMs": 9000,
        "status": {
          "kind": "stun",
          "durationMs": 800
        }
      },
      {
        "id": "savage_bite",
        "name": "Savage Bite",
        "kind": "cleave",
        "radius": 4,
        "mult": 1.8,
        "castMs": 700,
        "cooldownMs": 7000
      }
    ]
  },
  {
    "id": "grimtusk",
    "name": "Grimtusk",
    "level": 30,
    "hp": 13600,
    "xp": 30600,
    "ap": 148,
    "def": 77,
    "attackIntervalMs": 2100,
    "attackRange": 3,
    "aggroRadius": 10,
    "leashRadius": 40,
    "moveSpeed": 4.8,
    "radius": 1.3,
    "respawnMs": [600000, 600000],
    "color": "#4a3a2a",
    "scale": 2.1,
    "model": "boar:thorn",
    "boss": true,
    "abilities": [
      {
        "id": "earth_charge",
        "name": "Earth Charge",
        "kind": "slam",
        "radius": 5.5,
        "mult": 1.6,
        "castMs": 1300,
        "cooldownMs": 11000,
        "status": {
          "kind": "stun",
          "durationMs": 1200
        }
      },
      {
        "id": "tusk_rake",
        "name": "Tusk Rake",
        "kind": "cleave",
        "radius": 5,
        "mult": 1.8,
        "castMs": 850,
        "cooldownMs": 8000
      }
    ]
  },
  {
    "id": "bonecaller",
    "name": "Bonecaller",
    "level": 34,
    "hp": 16400,
    "xp": 33200,
    "ap": 167,
    "def": 86,
    "attackIntervalMs": 2100,
    "attackRange": 3,
    "aggroRadius": 10,
    "leashRadius": 40,
    "moveSpeed": 4.8,
    "radius": 0.9,
    "respawnMs": [600000, 600000],
    "color": "#6a6a8a",
    "scale": 1.7,
    "model": "humanoid:skeleton",
    "boss": true,
    "abilities": [
      {
        "id": "grave_bolt",
        "name": "Grave Bolts",
        "kind": "meteor",
        "radius": 3.5,
        "mult": 1.6,
        "castMs": 1500,
        "cooldownMs": 11000
      },
      {
        "id": "deathly_chill",
        "name": "Deathly Chill",
        "kind": "nova",
        "radius": 9,
        "mult": 1.2,
        "castMs": 1600,
        "cooldownMs": 16000,
        "status": {
          "kind": "slow",
          "durationMs": 3000,
          "pct": 40
        }
      }
    ]
  },
  {
    "id": "rift_shade",
    "name": "Umbral Shade",
    "level": 52,
    "hp": 10700,
    "xp": 16100,
    "ap": 205,
    "def": 117,
    "attackIntervalMs": 1500,
    "attackRange": 2.2,
    "aggroRadius": 7,
    "leashRadius": 35,
    "moveSpeed": 6.4,
    "radius": 0.8,
    "respawnMs": [30000, 40000],
    "color": "#0e0c18",
    "scale": 1.4,
    "model": "wolf:void"
  },
  {
    "id": "duskbound_sentinel",
    "name": "Duskbound Sentinel",
    "level": 55,
    "hp": 12100,
    "xp": 18900,
    "ap": 220,
    "def": 126,
    "attackIntervalMs": 2000,
    "attackRange": 2.4,
    "aggroRadius": 6,
    "leashRadius": 35,
    "moveSpeed": 4.6,
    "radius": 0.7,
    "respawnMs": [30000, 40000],
    "color": "#2a2834",
    "scale": 1.35,
    "model": "humanoid:wraith"
  },
  {
    "id": "voidstone_golem",
    "name": "Voidstone Golem",
    "level": 58,
    "hp": 13600,
    "xp": 22400,
    "ap": 232,
    "def": 134,
    "attackIntervalMs": 2600,
    "attackRange": 3.2,
    "aggroRadius": 5,
    "leashRadius": 35,
    "moveSpeed": 3.8,
    "radius": 1.3,
    "respawnMs": [30000, 40000],
    "color": "#1a1824",
    "scale": 2.1,
    "model": "golem:void"
  },
  {
    "id": "riftborn_stalker",
    "name": "Riftborn Stalker",
    "level": 60,
    "hp": 14800,
    "xp": 25200,
    "ap": 245,
    "def": 139,
    "attackIntervalMs": 1300,
    "attackRange": 2.2,
    "aggroRadius": 8,
    "leashRadius": 35,
    "moveSpeed": 6.8,
    "radius": 0.8,
    "respawnMs": [30000, 40000],
    "color": "#05040a",
    "scale": 1.6,
    "model": "wolf:void"
  },
  {
    "id": "cinder_wyrm",
    "name": "Skorvyn the Cinder Wyrm",
    "level": 72,
    "hp": 240000,
    "xp": 450000,
    "ap": 440,
    "def": 215,
    "attackIntervalMs": 2800,
    "attackRange": 5.5,
    "aggroRadius": 14,
    "leashRadius": 50,
    "moveSpeed": 4,
    "radius": 3.2,
    "respawnMs": [5400000, 7200000],
    "color": "#3a1a14",
    "scale": 3.2,
    "model": "dragon:ash",
    "boss": true,
    "abilities": [
      {
        "id": "flame_breath",
        "name": "Flame Breath",
        "kind": "cleave",
        "radius": 16,
        "mult": 2,
        "castMs": 1800,
        "cooldownMs": 12000,
        "status": {
          "kind": "slow",
          "durationMs": 3000,
          "pct": 40
        }
      },
      {
        "id": "wing_buffet",
        "name": "Wing Buffet",
        "kind": "nova",
        "radius": 12,
        "mult": 1.5,
        "castMs": 1400,
        "cooldownMs": 16000,
        "status": {
          "kind": "stun",
          "durationMs": 1500
        }
      },
      {
        "id": "firefall",
        "name": "Firefall",
        "kind": "meteor",
        "radius": 5,
        "mult": 2.4,
        "castMs": 1400,
        "cooldownMs": 8000
      }
    ]
  },
  {
    "id": "ashen_gladiator",
    "name": "Ashen Stinger",
    "level": 50,
    "hp": 9800,
    "xp": 14300,
    "ap": 195,
    "def": 112,
    "attackIntervalMs": 1900,
    "attackRange": 2.4,
    "aggroRadius": 6,
    "leashRadius": 30,
    "moveSpeed": 4.4,
    "radius": 0.7,
    "respawnMs": [45000, 60000],
    "color": "#4a4038",
    "scale": 1.3,
    "model": "scorpion"
  },
  {
    "id": "crown_champion",
    "name": "Crown Champion",
    "level": 56,
    "hp": 13000,
    "xp": 20000,
    "ap": 226,
    "def": 128,
    "attackIntervalMs": 2000,
    "attackRange": 2.4,
    "aggroRadius": 7,
    "leashRadius": 30,
    "moveSpeed": 4.6,
    "radius": 1.0,
    "respawnMs": [75000, 105000],
    "color": "#3a3448",
    "scale": 1.15,
    "model": "behemoth",
    "np": 8
  },
  {
    "id": "rimefang_wolf",
    "name": "Rimefang Wolf",
    "level": 48,
    "hp": 8900,
    "xp": 12700,
    "ap": 185,
    "def": 106,
    "attackIntervalMs": 1400,
    "attackRange": 2.2,
    "aggroRadius": 8,
    "leashRadius": 35,
    "moveSpeed": 6.6,
    "radius": 0.8,
    "respawnMs": [40000, 55000],
    "color": "#c8d8e8",
    "scale": 1.4,
    "model": "wolf:frost"
  },
  {
    "id": "rime_golem",
    "name": "Rime Golem",
    "level": 54,
    "hp": 11600,
    "xp": 17900,
    "ap": 214,
    "def": 122,
    "attackIntervalMs": 2600,
    "attackRange": 3.2,
    "aggroRadius": 5,
    "leashRadius": 35,
    "moveSpeed": 3.8,
    "radius": 1.3,
    "respawnMs": [40000, 55000],
    "color": "#a8c8dc",
    "scale": 2,
    "model": "golem:ice"
  },
  {
    "id": "hoarfrost_titan",
    "name": "The Hoarfrost Titan",
    "level": 66,
    "hp": 95000,
    "xp": 185000,
    "ap": 315,
    "def": 165,
    "attackIntervalMs": 2800,
    "attackRange": 4,
    "aggroRadius": 12,
    "leashRadius": 45,
    "moveSpeed": 3.6,
    "radius": 2,
    "respawnMs": [2400000, 3600000],
    "color": "#9ec4e0",
    "scale": 2.7,
    "model": "golem:ice",
    "boss": true,
    "abilities": [
      {
        "id": "glacial_slam",
        "name": "Glacial Slam",
        "kind": "slam",
        "radius": 8,
        "mult": 1.6,
        "castMs": 1600,
        "cooldownMs": 13000,
        "status": {
          "kind": "stun",
          "durationMs": 1500
        }
      },
      {
        "id": "frost_ring",
        "name": "Frost Ring",
        "kind": "nova",
        "radius": 12,
        "mult": 1.3,
        "castMs": 1500,
        "cooldownMs": 16000,
        "status": {
          "kind": "slow",
          "durationMs": 4000,
          "pct": 50
        }
      },
      {
        "id": "ice_shard",
        "name": "Ice Shard",
        "kind": "meteor",
        "radius": 4,
        "mult": 2,
        "castMs": 1300,
        "cooldownMs": 9000
      }
    ]
  },
  {
    "id": "magma_toad",
    "name": "Magma Toad",
    "level": 50,
    "hp": 9800,
    "xp": 14300,
    "ap": 195,
    "def": 112,
    "attackIntervalMs": 1700,
    "attackRange": 2.2,
    "aggroRadius": 6,
    "leashRadius": 35,
    "moveSpeed": 4.6,
    "radius": 0.9,
    "respawnMs": [40000, 55000],
    "color": "#5a2010",
    "scale": 1.7,
    "model": "toad:lava"
  },
  {
    "id": "slag_brute",
    "name": "Slag Brute",
    "level": 56,
    "hp": 12600,
    "xp": 20100,
    "ap": 224,
    "def": 128,
    "attackIntervalMs": 2600,
    "attackRange": 3.2,
    "aggroRadius": 5,
    "leashRadius": 35,
    "moveSpeed": 3.8,
    "radius": 1.3,
    "respawnMs": [40000, 55000],
    "color": "#3a2a22",
    "scale": 2,
    "model": "golem:slag"
  },
  {
    "id": "pyreheart",
    "name": "Pyreheart",
    "level": 68,
    "hp": 102000,
    "xp": 210000,
    "ap": 328,
    "def": 172,
    "attackIntervalMs": 2600,
    "attackRange": 4,
    "aggroRadius": 12,
    "leashRadius": 45,
    "moveSpeed": 3.8,
    "radius": 2,
    "respawnMs": [2400000, 3600000],
    "color": "#4a2a1a",
    "scale": 2.8,
    "model": "golem:slag",
    "boss": true,
    "abilities": [
      {
        "id": "molten_slam",
        "name": "Molten Slam",
        "kind": "slam",
        "radius": 8,
        "mult": 1.7,
        "castMs": 1600,
        "cooldownMs": 13000,
        "status": {
          "kind": "stun",
          "durationMs": 1500
        }
      },
      {
        "id": "lava_ring",
        "name": "Lava Ring",
        "kind": "nova",
        "radius": 12,
        "mult": 1.4,
        "castMs": 1500,
        "cooldownMs": 16000,
        "status": {
          "kind": "slow",
          "durationMs": 3000,
          "pct": 40
        }
      },
      {
        "id": "magma_burst",
        "name": "Magma Burst",
        "kind": "meteor",
        "radius": 4.5,
        "mult": 2.1,
        "castMs": 1400,
        "cooldownMs": 9000
      }
    ]
  },
  {
    "id": "war_keeper_human",
    "name": "Valcrest War Keeper",
    "level": 65,
    "hp": 380000,
    "xp": 0,
    "ap": 360,
    "def": 200,
    "attackIntervalMs": 2000,
    "attackRange": 4,
    "aggroRadius": 16,
    "leashRadius": 28,
    "moveSpeed": 4.8,
    "radius": 1.9,
    "respawnMs": [0, 0],
    "color": "#3a5a9a",
    "scale": 2.6,
    "model": "humanoid:keeper_human",
    "boss": true,
    "np": 60,
    "nation": "human",
    "abilities": [
      {
        "id": "bastion_slam",
        "name": "Bastion Slam",
        "kind": "slam",
        "radius": 8,
        "mult": 1.6,
        "castMs": 1500,
        "cooldownMs": 12000,
        "status": {
          "kind": "stun",
          "durationMs": 1500
        }
      },
      {
        "id": "crown_sweep",
        "name": "Crown Sweep",
        "kind": "cleave",
        "radius": 7,
        "mult": 2.0,
        "castMs": 900,
        "cooldownMs": 8000
      },
      {
        "id": "judgment_of_valcrest",
        "name": "Judgment of Valcrest",
        "kind": "nova",
        "radius": 14,
        "mult": 1.5,
        "castMs": 1600,
        "cooldownMs": 16000,
        "status": {
          "kind": "slow",
          "durationMs": 3000,
          "pct": 40
        }
      }
    ]
  },
  {
    "id": "war_keeper_orc",
    "name": "Gorzhak War Keeper",
    "level": 65,
    "hp": 380000,
    "xp": 0,
    "ap": 360,
    "def": 200,
    "attackIntervalMs": 2000,
    "attackRange": 4,
    "aggroRadius": 16,
    "leashRadius": 28,
    "moveSpeed": 4.8,
    "radius": 1.9,
    "respawnMs": [0, 0],
    "color": "#8a2a1a",
    "scale": 2.6,
    "model": "humanoid:keeper_orc",
    "boss": true,
    "np": 60,
    "nation": "orc",
    "abilities": [
      {
        "id": "earthbreaker",
        "name": "Earthbreaker",
        "kind": "slam",
        "radius": 8,
        "mult": 1.6,
        "castMs": 1500,
        "cooldownMs": 12000,
        "status": {
          "kind": "stun",
          "durationMs": 1500
        }
      },
      {
        "id": "reaping_arc",
        "name": "Reaping Arc",
        "kind": "cleave",
        "radius": 7,
        "mult": 2.0,
        "castMs": 900,
        "cooldownMs": 8000
      },
      {
        "id": "skyfire",
        "name": "Skyfire",
        "kind": "meteor",
        "radius": 5,
        "mult": 1.8,
        "castMs": 1800,
        "cooldownMs": 14000
      }
    ]
  },
  {
    "id": "event_frostbeard",
    "name": "Old Frostbeard",
    "level": 30,
    "hp": 45000,
    "xp": 0,
    "ap": 60,
    "def": 60,
    "attackIntervalMs": 2400,
    "attackRange": 3,
    "aggroRadius": 0,
    "leashRadius": 30,
    "moveSpeed": 3.2,
    "radius": 1.4,
    "respawnMs": [0, 0],
    "color": "#c8302a",
    "scale": 1.9,
    "model": "humanoid:frostbeard",
    "boss": true,
    "event": {
      "xpPct": 4
    },
    "abilities": [
      {
        "id": "snowball_volley",
        "name": "Snowball Volley",
        "kind": "meteor",
        "radius": 4,
        "mult": 0.4,
        "castMs": 1400,
        "cooldownMs": 9000,
        "status": {
          "kind": "slow",
          "durationMs": 2500,
          "pct": 30
        }
      },
      {
        "id": "belly_laugh",
        "name": "Belly Laugh",
        "kind": "slam",
        "radius": 6,
        "mult": 0.3,
        "castMs": 1200,
        "cooldownMs": 12000,
        "status": {
          "kind": "stun",
          "durationMs": 800
        }
      }
    ]
  },
  {
    "id": "event_gilded_imp",
    "name": "Gilded Imp",
    "level": 20,
    "hp": 5000,
    "xp": 0,
    "ap": 20,
    "def": 20,
    "attackIntervalMs": 1600,
    "attackRange": 2,
    "aggroRadius": 0,
    "leashRadius": 40,
    "moveSpeed": 5.5,
    "radius": 0.7,
    "respawnMs": [0, 0],
    "color": "#e8b84a",
    "scale": 0.75,
    "model": "humanoid:gilded_imp",
    "event": {
      "xpPct": 1.5
    }
  },
  {
    "id": "clash_crystal",
    "name": "Clash Crystal",
    "level": 38,
    "hp": 200000,
    "ap": 0,
    "def": 82,
    "radius": 1.6,
    "color": "#7fd8ff",
    "scale": 1.6,
    "xp": 0,
    "attackIntervalMs": 60000,
    "attackRange": 1,
    "aggroRadius": 0,
    "leashRadius": 1,
    "moveSpeed": 0.1,
    "respawnMs": [0, 0],
    "model": "crystal",
    "boss": true,
    "crystal": true
  },
  {
    "id": "greater_clash_crystal",
    "name": "Greater Clash Crystal",
    "level": 58,
    "hp": 490000,
    "ap": 0,
    "def": 133,
    "radius": 1.8,
    "color": "#9fe4ff",
    "scale": 1.8,
    "xp": 0,
    "attackIntervalMs": 60000,
    "attackRange": 1,
    "aggroRadius": 0,
    "leashRadius": 1,
    "moveSpeed": 0.1,
    "respawnMs": [0, 0],
    "model": "crystal",
    "boss": true,
    "crystal": true
  }
]
